import { createGenericFetchMachine } from '@/common/overmind/machines/generic-fetch-machine';
import type { LayerInfo } from '@/overmind/effects/adapters/baseadapter';

import * as actions from './actions';

const state = createGenericFetchMachine<LayerInfo[]>();

export { state, actions };
